<template>
  <div class="md:flex">
    <FormLabel>
      <slot name="label"></slot>
      <span class="text-red-500" v-if="required">*</span>
    </FormLabel>

    <div class="md:w-7/12 md:px-2 xl:w-6/12" :class="!!$slots.link ? 'flex items-center' : ''">
      <slot name="field"></slot>
      <slot name="link"></slot>
      <span class="block mt-1 text-xs text-gray-500" v-if="!!$slots.help">
        <slot name="help"></slot>
      </span>
      <slot name="misc"></slot>

      <slot name="error"></slot>
    </div>

    <slot name="extension"></slot>
  </div>
</template>

<script>
export default {
  name: "FormRow",
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    footer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
